import React, { Component, PropTypes } from 'react';
import { Panel, Collapse } from 'react-bootstrap';
import moment from 'moment';
import * as Api from 'api';
import { hasPermission } from 'actions';
import { DOWNLOAD_DATA_LIST } from 'permissions';
import { connect } from 'react-redux';
import { parsePhone } from 'utils';

const getComponent = (typeName, address_components) => {
  for (var i = 0; i < address_components.length; i++) {
    const { types, long_name, short_name } = address_components[i];
    if(types.find(type => type == typeName)) {
      switch(typeName) {
        case 'route':
          return short_name;
        case 'administrative_area_level_1':
          return short_name;
        default:
          return long_name;
      }
    }
  }
};

const ListItem = props => props.value ? (
  <li><b><i className={`fa fa-1x fa-${props.icon}`}></i> {props.label}:</b> {!props.value ? 'Not available.' : props.parse? props.parse(props.value) : props.value}</li>
) : null;

class ContactDetails extends Component {
  static propTypes = {
    place: PropTypes.object,
    contact: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.contact ? false : true,
      contact: this.props.contact,
      error: undefined,
      show_autos: false
    }

    this.mounted = false;
    this.ContactItem = this.ContactItem.bind(this);
  }
  ContactItem({ prop, icon, parse }) {
    const path = prop.split('.');
    let value = this.state.contact;
    const pathCopy = prop.split('.');

    while(pathCopy.length > 0) {
      const propName = pathCopy.shift();
      value = value[propName];
    }

    const label = path[path.length - 1].split('_').map(item => `${item[0].toUpperCase()}${item.slice(1,item.length)}`).join(' ');
    return <ListItem label={label} value={value} icon={icon} parse={parse} />
  }
  componentDidMount() {
    this.mounted = true;
    const { place } = this.props;

    if(place && !place.address_components) {
      this.setState({ loading: false });
    }

    if(place && place.address_components && this.props.hasPermission(DOWNLOAD_DATA_LIST)) {
      let options = {
        street_name: getComponent('route', place.address_components),
        house_number: getComponent('street_number', place.address_components),
        city: getComponent('locality', place.address_components),
        zip: getComponent('postal_code', place.address_components),
        state: getComponent('administrative_area_level_1', place.address_components)
      }

      Api.findContact(options).then(({data}) => {
        if(data && this.mounted) {
          this.setState({
            contact: {
              ...data,
              address: {
                ...data.address,
                feature: {
                  ...data.address.feature,
                  geometry: { ...data.address.feature.geometry, coordinates: [ place.geometry.location.lng(), place.geometry.location.lat() ]}
                }
              }
            }, loading: false });
        }
        else {
          this.setState({ loading: false });
        }
      }).catch(error => this.setState({ error, loading: false }));

    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { contact } = this.state;
    const { place_details: PlaceDetails } = this.props;
    const { ContactItem } = this;
    const { render_buttons: RenderButtons } = this.props;

    if(!this.props.hasPermission(DOWNLOAD_DATA_LIST)) {
      return PlaceDetails || null
    }

    if(this.state.loading && !contact) {
      return (
        <div className="text-center">
          <i className='fa fa-spinner fa-spin'></i> Finding more info...
        </div>
      )
    }

    if(!contact && PlaceDetails && !this.state.loading) {
      return PlaceDetails
    }

    if(!contact) {
      return null;
    }
    const { address } = contact;
    const longitude = address ? address.feature ? address.feature.geometry.coordinates[0] : 0 : 0;
    const latitude = address ? address.feature ? address.feature.geometry.coordinates[1] : 0 : 0;
    const apiKey = 'AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw';
    const pitch = -18.26;
    const heading = null;
    const fullAddress = `${ address ? address.street : ''}, ${ address ? address.city : '' } ${ address? address.state : '' } ${ address ? address.zip : '' }`;
    const googleImage = `${'https://'}maps.googleapis.com/maps/api/streetview?size=600x400&fov=110&location=${ latitude },${ longitude }&heading=${ heading }&pitch=${ pitch }&key=${ apiKey }`;
    const props = { ...this.props, contact: undefined };
    const Header = props => (
      null
    );
    return (
      <section className="animated fadeInDown client-details-container">
        <div className="thumb-info mb-md">
          <img src={googleImage} className="rounded img-responsive" alt="John Doe"/>
          <div className="thumb-info-title">
            <span className="thumb-info-inner">{contact.name}</span>
            <span className="thumb-info-type">{fullAddress}</span>
          </div>
        </div>
        <h4 className="text-muted">Contact Details</h4>
        <hr className='short'/>
        <ul className="list-unstyled mb-sm ">
          <ContactItem prop='gender' icon='venus-mars' />
          <ContactItem prop='phone' parse={parsePhone} icon='phone' />
          <ContactItem prop='cell_phone' parse={parsePhone} icon='mobile' />
          {contact.cell_phone_dnc == 'Y' || contact.phone_dnc == 'Y' ? (
            <li className="text-center text-danger">
              <span className="fa-stack fa-lg">
                <i className="fa fa-phone fa-stack-1x"></i>
                <i className="fa fa-ban fa-stack-2x text-danger"></i>
              </span> Do not call!
            </li>
          ) : null}
          <ContactItem prop='email' icon='envelope' />
          <ContactItem prop='dob' icon='calendar' parse={value => moment(value).format('MMM DD, YYYY')} />
          {/* <ContactItem prop='address.street' icon='home' /> */}
          <ContactItem prop='home_value' icon='dollar' parse={({ min, max }) => `$${ min.toLocaleString() } - $${ max.toLocaleString() }`} />
          <ContactItem prop='estimated_home_value' icon='dollar' />
          <ContactItem prop='purchase_amount' icon='dollar' />
          <ContactItem prop='dwelling_type' icon='info' />
          <ContactItem prop='building_square_footage' parse={value => `${value} sq. ft.`} icon='th-large' />
          <ContactItem prop='length_of_residence' parse={value => `${value} years`} icon='clock-o' />
          <hr className="mt-xs mb-xs" />
          <ContactItem prop='has_motorcycle' icon='motorcycle' />
          <ContactItem prop='has_rv' icon='bus' />
          <ContactItem prop='has_boat' icon='ship' />
          <ContactItem prop='autos' parse={values => values && values.length > 0 ? (
            <div>
              <Collapse in={this.state.show_autos}>
                <div>
                  {values.map((value, idx) => (
                    <div key={value.vin} className="well well-sm dark mb-xs">
                      <ul className="list-unstyled">
                        <li>Vin: {value.vin}</li>
                        <li>Make: {value.make}</li>
                        <li>Model: {value.model}</li>
                        <li>Year: {value.year}</li>
                      </ul>
                    </div>
                  ))}
                </div>
              </Collapse>
              <div className="text-center">
                <a href="#" onClick={e => {
                  e.preventDefault();
                  this.setState({show_autos: !this.state.show_autos});
                }}>{this.state.show_autos ? 'Hide Autos' : 'Show Autos'}</a>
              </div>
            </div>
          ) : null} icon='car' />

        </ul>
        {this.props.children}
        {RenderButtons ? <RenderButtons contact={this.state.contact} place={this.props.place} /> : null}
      </section>
    )
  }
}

export default connect(() => ({}), { hasPermission })(ContactDetails);



// WEBPACK FOOTER //
// ./src/browser/components/clients/contact-details.js